import stoneService from '@services/magento/stone.service';

export async function searchStoneByIdApi(id: string | number): Promise<{ item: any; steps: any[] }> {
  const response = await stoneService.getStoneOptionsFlowById(id);
  return { item: response?.item || null, steps: response?.steps || [] };
}
